import stringUtil from "@/utils/string-util";
import { STYLE } from "@/static/global-variables";

class Highlight {
  findText(text, words) {
    if (!words || !text) {
      return text;
    }
    let txt = text;
    const wordsArray = [...words];
    const keys = stringUtil.hasSpecialChars(wordsArray)
      ? this.escapeWords(wordsArray)
      : wordsArray;
    const foundKeys = new Set();
    const tmpText = text.replace(new RegExp(keys.join("|"), "gi"), function(
      match
    ) {
      let replacement;
      if (words.has(match.toLowerCase())) {
        replacement = `<span class="${STYLE.UI_ACTION.HIGHTLIGHT_TEXT}">${match}</span>`;
        foundKeys.add(match.toLowerCase());
      }
      return replacement;
    });
    if (foundKeys.size === words.size) {
      txt = tmpText;
    }
    return txt;
  }

  escapeWords(keys) {
    return keys ? keys.map(e => stringUtil.escapeEpecialCharacters(e)) : [];
  }

  find(text, exp) {
    if (!exp || !text) {
      return text;
    }
    const tokens = exp
      .replace(/\s+/g, " ")
      .trim()
      .split(" ");
    const words = new Set(tokens.map(e => e.toLowerCase()));
    return this.findText(text, words);
  }
}

const highlight = new Highlight();

export { highlight };
